export const UPDATE_PAGE_DATA = "KPI_APP_ANALYTICS_UPDATE_PAGE_DATA";
export const UPDATE_PAGE_DATA_LOADER = "UPDATE_PAGE_DATA_LOADER";
export const UPDATE_PAGE_DATA_EXTRA = "UPDATE_PAGE_DATA_EXTRA";
export const UPDATE_DATA_SESSION = "UPDATE_DATA_SESSION";
export const UPDATE_UNTRACKED = "UPDATE_UNTRACKED";
export const UPDATE_REGISTERED = "UPDATE_REGISTERED";
